import { useState } from 'react'
import { Icon } from '@iconify/react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

// antd
import { Form, Input, Typography, message } from 'antd'

// slices
import { passwordForgot } from './login.slice'

// routes
import { PUBLIC_ROUTES } from '../../routes'

// assets
import logo from '../../assets/images/logo.png'

// components
import Button from '../../components/button/button'
import { FORM_VALIDATION_RULES } from '../../constants/validationRules/form'

// css
import './LoginForm.css'
import { showActionNotification } from '../../components/notification'

function ForgotPassword() {
    const [form] = Form.useForm()

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { Text } = Typography

    const [loadingButton, setLoadingButton] = useState(false)

    async function onSendOTP(values) {
        const email = values?.email?.trim()

        if (!email) {
            showActionNotification({
                type: 'error',
                message: 'Please enter your email address',
            })
            return
        }

        setLoadingButton(true)

        const result = await dispatch(passwordForgot({ email }))
        const data = result?.payload?.data

        setLoadingButton(false)

        if (!data) {
            return showActionNotification({
                type: 'error',
                message: 'Something went wrong',
            })
        }

        data.success
            ? showActionNotification({
                  type: 'success',
                  message: data.message,
              })
            : showActionNotification({
                  type: 'error',
                  message: data.message || 'Something went wrong',
              })
    }

    return (
        <div className="glass-card">
            <div className="login-logo-container">
                <img src={logo} alt="logo" className="login-form-logo-img" />
            </div>

            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    marginBottom: 24,
                }}
            >
                <Text
                    style={{
                        color: 'rgba(255, 255, 255, 0.7)',
                        cursor: 'pointer',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 8,
                        fontSize: 14,
                    }}
                    onClick={() => navigate(PUBLIC_ROUTES.login)}
                >
                    <Icon icon="mdi:arrow-left" width={20} height={20} />
                    Back to sign in
                </Text>
            </div>

            <h2 className="welcome-title">Forgot your password?</h2>
            <p className="welcome-subtitle">
                Enter your email and we&apos;ll send you reset instructions.
            </p>

            <Form
                layout="vertical"
                form={form}
                onFinish={onSendOTP}
                requiredMark={false}
                autoComplete="off"
                className="custom-login-form"
                style={{
                    rowGap: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Form.Item
                    name="email"
                    rules={FORM_VALIDATION_RULES.email.rules}
                >
                    <Input
                        className="custom-input"
                        placeholder="Me@example.com"
                        autoComplete="off"
                    />
                </Form.Item>

                <Button
                    props={{
                        text: 'Reset Password',
                        htmlType: 'submit',
                        className: 'login-submit-btn',
                        disabled: loadingButton,
                        loadingButton: loadingButton,
                    }}
                />
            </Form>
        </div>
    )
}

export default ForgotPassword
